import { __assign } from "tslib";
import hexToRgba from 'hex-rgba';
import spcColors from './spcColors';
import paletteDark from './paletteDark';
var black = spcColors.black,
    gray = spcColors.gray,
    white = spcColors.white,
    negative = spcColors.negative,
    accent = spcColors.accent,
    dark = spcColors.dark;

var spcDarkPalette = __assign(__assign({}, paletteDark), {
  background: {
    neutral: {
      primary: '#27272B',
      secondary: '#2D2C30',
      tertiary: '#1F1F21',
      popover: '#2D2C30',
      primaryTransparent: 'rgba(40, 39, 43, 0.56)',
      tertiaryTransparent: 'rgba(31, 31, 33, 0.56)',
      dialogOverlay: 'rgba(0, 0, 0, 0.56)'
    },
    semantic: {
      warning: '#4C4026',
      accent: '#2F394A',
      positive: '#2C3633',
      negative: '#472E31',
      positiveGradient: 'linear-gradient(180deg, #141A26 0%, #152E36 50%, #133833 100%)',
      negativeGradient: 'linear-gradient(180deg, #1D1A26 0%, #2D202E 50.99%, #472E3A 100%)'
    }
  },
  label: {
    accent: '#7CA6F4',
    accentHigh: '#7CA6F4',
    accentHighest: '#7CA6F4',
    primary: '#E7E6EB',
    secondary: '#A6A3AD',
    secondaryHigh: '#D2D1D7',
    tertiary: '#817E87',
    tertiaryHigh: '#97959E',
    placeholder: '#65646B',
    inactive: 'rgba(154, 151, 161, 0.4)',
    positive: '#45BA8D',
    negative: '#FF6164',
    warning: '#F7CC1E',
    inverse: '#0A0A0A',
    primaryActive: '#7CA6F4',
    secondaryActive: '#D2D1D7',
    tertiaryActive: '#97959E',
    plaseholder: '#65646B'
  },
  fill: __assign(__assign({}, paletteDark.fill), {
    primary: {
      highest: '#8CB0F5',
      high: '#6A99EB',
      mid: '#5B8DE3',
      low: '#4972B8',
      muted: '#39578F',
      overlay32: 'rgba(87, 142, 235, 0.32)',
      overlay24: 'rgba(87, 142, 235, 0.24)',
      overlay16: 'rgba(87, 142, 235, 0.16)',
      overlay8: 'rgba(87, 142, 235, 0.08)'
    }
  }),
  static: __assign(__assign({}, paletteDark.static), {
    primary: '#7CA6F4',
    primaryAlfa32: 'rgba(91, 141, 227, 0.32)'
  }),
  base: {
    accent: accent[1],
    error: negative[2],
    disabled: black[3]
  },
  input: {
    main: {
      text: white['2'],
      background: hexToRgba(gray['2'], 8),
      backgroundDisabled: hexToRgba(gray['2'], 4),
      backgroundHover: hexToRgba(gray['2'], 16),
      backgroundError: hexToRgba(negative['2'], 8),
      border: black['3'],
      borderDisabled: hexToRgba(black['3'], 56),
      borderHover: gray['1'],
      borderError: negative['2']
    },
    label: gray['2'],
    message: gray['2']
  },
  menuItem: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundSelected: hexToRgba(accent['1'], 16)
  },
  button: {
    backgroundDisabled: hexToRgba(gray['2'], 6),
    border: hexToRgba(accent['1'], 32),
    borderDisabled: hexToRgba(white['1'], 8)
  },
  iconButton: {
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundFocused: hexToRgba(accent['1'], 16)
  },
  toggle: {
    background: black['2'],
    backgroundHover: hexToRgba(accent['1'], 8),
    backgroundActivated: hexToRgba(accent['1'], 16)
  },
  text: {
    primary: white['2'],
    secondary: gray['2']
  },
  paper: __assign(__assign({}, paletteDark.paper), {
    background: black['2']
  }),
  modal: {
    backdrop: hexToRgba(black['0'], 50)
  },
  dialog: {
    background: black['2']
  },
  dropDown: {
    background: dark['1']
  },
  dividerLegacy: {
    primary: dark['5'],
    secondary: dark['6']
  },
  switch: {
    icon: gray['3'],
    shadow: paletteDark.switch.shadow,
    track: gray['2']
  },
  calendar: {
    day: {
      backgroundHover: hexToRgba(black['1'], 56),
      backgroundCurrent: hexToRgba(accent['1'], 16)
    }
  },
  avatar: {
    backgroundPrimary: black['0'],
    backgroundSecondary: black['1']
  },
  snackbar: {
    text: black['1'],
    background: white['2']
  },
  tooltip: {
    background: hexToRgba(black['0'], 90),
    color: white['1']
  }
});

export default spcDarkPalette;